// Konfiguracja – placeholdery do podmiany w scripts.js
const params = new URLSearchParams(window.location.search);

const grenkeConfig = {
    //settings mode
    mode: "dev",
    modeViewGrenke: params.get("dev") === "true" ? true : false,
    //end settings mode
    //Product Page Information
    productPageText: "Get this product on a flexible multi-year leasing option with Grenke. Find out more",
    productPageTextClass: ".hdt-main-section--product .hdt-main-product .hdt-product-info-wrapp .hdt-product__buy-button ",
    productPageTitleClass: ".hdt-main-section--product .hdt-main-product .hdt-product__title .hdt-product__title",
    //end Product Page Information
    //Basket Button
    productShopCartText: "Calculate leasing installments with Grenke",
    productShopCartTextClass: ".hdt-section-main-cart .hdt-page-cart__wrap .hdt-page-cart__footer .additional-checkout-buttons",
    //end Basket Button
    //Selceted/Chosen Products
    productShopCartListCheck: "Flexible multi-year leasing option with Grenke",
    productShopCartListCheckClass: ".hdt-section-main-cart .hdt-cart-page__items .hdt-cart-item .hdt-page-cart__info .hdt-page-cart__title",
    selectListProducts: "selected",
    //end Selceted/Chosen Products
    //List of Selceted/Chosen Products
    productNameList: ["Bambu Lab H2D Laser Full Combo (40 W) 3D Printer","Bambu Lab H2D Laser Full Combo (10 W) 3D Printer","Bambu Lab H2D AMS Combo","Bambu Lab H2D","Bambu Lab X1E Combo","Bambu Lab X1C Combo","Bambu Lab X1C","Bambu Lab P1S Combo","Bambu Lab P1S","Bambu Lab A1 Combo","Bambu Lab A1","Bambu Lab A1 Mini Combo","Bambu Lab A1 Mini ","Creality K2 Plus Combo","Creality K2 Plus","Phrozen Sonic Mega 8K V2","Phrozen Sonic Mega 8K S"],
    //end List of Selceted/Chosen Products
    //Class collection for cart information
    productShopCartClass: ".hdt-section-main-cart .hdt-cart-page__items .hdt-cart-item ", 
    productShopCartPriceClass: ".hdt-price__item .hdt-price .hdt-money",
    productShopCartCountClass: ".hdt-cart-item__quantity .quantity__input",
    productShopCartNameClass: ".hdt-page-cart__info .hdt-page-cart__title", 
    productShopCartImageClass: ".hdt-page-cart__image .hdt-page-cart__img img",
    //end Class collection for cart information
    //partner
    partnerId: "15092025",
    partnerEmail: "dawid.dobrzynski@norddigital.com",
    //end partner
    logoGrenkePath: "https://generator-grenke-ae.hekko24.pl/images/grenke-logo.svg",
};

function generateUrl() {
    const baseUrl = "https://grenke-calculator.ae/shop";

    const cartItems = document.querySelectorAll(`${grenkeConfig.productShopCartClass}`); // lista produktów
    const products = [];

    cartItems.forEach((item) => {
        const nameEl = item.querySelector(`${grenkeConfig.productShopCartNameClass}`);
        const priceEl = item.querySelector(`${grenkeConfig.productShopCartPriceClass}`);
        const countEl = item.querySelector(`${grenkeConfig.productShopCartCountClass}`);
        const imgEl = item.querySelector(`${grenkeConfig.productShopCartImageClass}`);

        //format price
        const rawPrice = priceEl ? priceEl.textContent.trim() : "";
        let numeric = rawPrice.replace(/[^0-9.,]/g, "");
        numeric = numeric.replace(/[\s,.](?=\d{3}(\D|$))/g, "");
        numeric = numeric.replace(",", ".");
        const priceNumber = parseFloat(numeric);
        const price = isNaN(priceNumber) ? "" : priceNumber.toFixed(2).replace(".", ",");
        // end format price
        const count = countEl ? countEl.value : "";
        const imgSrc = imgEl ? imgEl.src : "";

        const productName = Array.from(nameEl.childNodes)
        .filter(node => node.nodeType === Node.TEXT_NODE) // węzły tekstowe
        .map(node => node.textContent.trim())
        .join(" ");
        // dodaj produkt jako obiekt
        if(grenkeConfig.selectListProducts == "selected") {
            if (grenkeConfig.productNameList.includes(productName)) {
                products.push({ productName, price, count, imgSrc });
            }
        }else{
            products.push({ productName, price, count, imgSrc });
        }
    });

    // serializacja do JSON
    const jsonData = JSON.stringify(products);
    // szyfrowanie AES
    const encodedData = btoa(unescape(encodeURIComponent(jsonData)));
    const encodedPartnerId = btoa(unescape(encodeURIComponent(grenkeConfig.partnerId)));
    const encodedPartnerEmail = btoa(unescape(encodeURIComponent(grenkeConfig.partnerEmail)));
    // pełny URL
    const fullUrl = `${baseUrl}?data=${encodedData}&pi=${encodedPartnerId}&pe=${encodedPartnerEmail}`;
    console.log(fullUrl);
    return fullUrl;
}

function addGrenkeToProductPage() {
    const productPlace = document.querySelector(`${grenkeConfig.productPageTextClass}`); //ścieżka gdzie umieścić nowy div grenke
    const titles = document.querySelectorAll(`${grenkeConfig.productPageTitleClass}`); //sprawdź nazwe produktu
    let existsProduct = false;
    if(grenkeConfig.selectListProducts == "selected") {
        //search product
        titles.forEach((title) => {
            const productName = title.textContent.trim().toLowerCase();
            if (grenkeConfig.productNameList.some(name => productName === name.toLowerCase())) {
                existsProduct = true;
            }
        });
    }else{
        existsProduct = true;
    }
    if (productPlace && existsProduct) {
        //new div
        const newDiv = document.createElement("div");
        newDiv.textContent = `${grenkeConfig.productPageText}`;
        //style
        newDiv.style.display = "flex";
        newDiv.style.justifyContent = "space-between";
        newDiv.style.color = "#000000";
        newDiv.style.fontSize = "13px";
        newDiv.style.padding = "10px";
        newDiv.style.border = "1px solid #fbb900";
        newDiv.style.marginTop = "15px";
        newDiv.style.borderRadius = "5px";
        newDiv.style.backgroundColor = "#ffffff";
        if(grenkeConfig.mode == "dev" && !grenkeConfig.modeViewGrenke) {
            newDiv.style.display = "none";
        }
        //logo
        const img = document.createElement("img");
        img.src = grenkeConfig.logoGrenkePath;
        img.alt = "grenke.ae";
        img.style.maxWidth = "50px";
        img.style.marginLeft = "10px";
        img.style.display = "inline-block";
        if(grenkeConfig.mode == "dev" && !grenkeConfig.modeViewGrenke) {
            img.style.display = "none";
        }
        //add logo to div
        newDiv.appendChild(img);
        // wstaw
        productPlace.appendChild(newDiv);
    }
}

function addGrenkeToCartProducts() {
    if(grenkeConfig.productShopCartListCheckClass) {
        const cartProducts = document.querySelectorAll(`${grenkeConfig.productShopCartListCheckClass}`);

        if(cartProducts) {
            cartProducts.forEach((cartProduct) => {
                let existsProduct = false;

                // jeśli nie masz osobnego selektora tytułu, sprawdź cały tekst w cartProduct
                const productName = cartProduct.textContent.trim();
                if (grenkeConfig.selectListProducts === "selected") {
                    if (grenkeConfig.productNameList.some(name => productName === name)) {
                        existsProduct = true;
                    }
                } else {
                    existsProduct = true;
                }

                if (existsProduct) {
                    const newDiv = document.createElement("div");
                    newDiv.textContent = `${grenkeConfig.productShopCartListCheck}`;
                    newDiv.style.display = "flex";
                    newDiv.style.justifyContent = "space-between";
                    newDiv.style.color = "#000000";
                    newDiv.style.fontSize = "13px";
                    newDiv.style.padding = "5px";
                    newDiv.style.border = "1px solid #fbb900";
                    newDiv.style.marginTop = "10px";
                    newDiv.style.borderRadius = "5px";
                    newDiv.style.width = "max-content";
                    newDiv.style.backgroundColor = "#ffffff";
                    if(grenkeConfig.mode == "dev" && !grenkeConfig.modeViewGrenke) {
                        newDiv.style.display = "none";
                    }
                    // wstaw element przy konkretnym produkcie
                    cartProduct.appendChild(newDiv);
                }
            });
        }
    }
}

function addGrenkeBtntoCart() {
    // znajdź miejsce w koszyku, obok którego wstawić przycisk
    const container = document.querySelector(grenkeConfig.productShopCartTextClass);
    if (!container) return; // jeśli nie ma miejsca, zakończ

    // utwórz link/przycisk
    const btn = document.createElement("a");
    btn.href = generateUrl();
    btn.innerHTML = `${grenkeConfig.productShopCartText} <span style="margin-left:5px;">→</span>`;
    btn.target = "_blank"; // otwórz w nowej karcie
    btn.style.display = "flex";
    btn.style.alignContent = "center";
    btn.style.justifyContent = "space-between";
    btn.style.padding = "10px 20px";
    btn.style.backgroundColor = "#ffffff";
    btn.style.color = "#000000";
    btn.style.textDecoration = "none";
    btn.style.borderRadius = "5px";
    btn.style.marginTop = "15px";
    btn.style.textAlign = "center";
    btn.style.width = "100%";
    btn.style.border = "1px solid #fbb900";
    if(grenkeConfig.mode == "dev" && !grenkeConfig.modeViewGrenke) {
        btn.style.display = "none";
    }
    //logo
    const img = document.createElement("img");
    img.src = grenkeConfig.logoGrenkePath;
    img.alt = "grenke.ae";
    img.style.maxWidth = "50px";
    img.style.marginLeft = "10px";
    img.style.display = "inline-block";
    if(grenkeConfig.mode == "dev" && !grenkeConfig.modeViewGrenke) {
        img.style.display = "none";
    }
    //add logo to div
    btn.appendChild(img);
    // wstaw przycisk **jako brata** kontenera (po nim)
    container.insertAdjacentElement("afterend", btn);
}

document.addEventListener("DOMContentLoaded", () => {
    console.log("Grenke config loaded:", grenkeConfig);
    //product page
    addGrenkeToProductPage();
    //end product page
    //cart page products
    addGrenkeToCartProducts(); 
    //end cart page products
    //grenke btn cart
    addGrenkeBtntoCart();
    //end grenke btn cart
});